import { render, staticRenderFns } from "./initia_Item.vue?vue&type=template&id=2d75b586&scoped=true"
import script from "./initia_Item.vue?vue&type=script&lang=js"
export * from "./initia_Item.vue?vue&type=script&lang=js"
import style0 from "./initia_Item.vue?vue&type=style&index=0&id=2d75b586&prod&lang=less&scoped=true"
import style1 from "./initia_Item.vue?vue&type=style&index=1&id=2d75b586&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d75b586",
  null
  
)

export default component.exports